import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { Elements } from '@stripe/react-stripe-js'
import { propTypes as formPropTypes } from 'redux-form'
import { lpForm } from 'lp-form'
import { StripeContext } from 'contexts'
import { createStripeOptions } from 'utils/stripeOptions'
import StripeGiftPaymentFormContent from './StripeGiftPaymentFormContent'

const propTypes = {
  ...formPropTypes,
  handleSubmit: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onSubmit: PropTypes.func,
  stripeClientSecretId: PropTypes.string.isRequired,
}

function StripeGiftPaymentForm({ stripeClientSecretId, ...props }) {
  const stripePromise = useContext(StripeContext)

  if (!stripeClientSecretId) return null

  return (
    <Elements
      stripe={stripePromise}
      options={createStripeOptions(stripeClientSecretId)}
    >
      <StripeGiftPaymentFormContent {...props} />
    </Elements>
  )
}

StripeGiftPaymentForm.propTypes = propTypes

export default compose(
  lpForm({
    name: 'StripeGiftPaymentForm',
  }),
)(StripeGiftPaymentForm)
